<!-- 折线图 -->
<style lang="stylus" scoped>
.bar-wrap {
  height: 816px;
  width: 1235px;
  margin-left: 40px;
  background: url('../../../../static/img/industryInformation/map-bg.png');
  padding: 50px 30px;
  box-sizing: border-box;
  position: relative;

  .map {
    width: 1200px;
    height: 700px;
    background-color: transparent !important;
  }
  .modal{
    position: absolute;
    width: 230px;
    height: 80px;
    background: rgba(7,49,81,.8);
    top: 300px;
    left: 300px;
    z-index: 1000;
    color: #fff;
    font-size: 20px;
    padding: 20px;
    box-sizing: border-box;
  }
}
</style>

<style>
.amap-logo,
.amap-copyright {
  display: none !important;
}
</style>


<template>
  <div class="bar-wrap">
    <div class="modal" v-show="isClick">
      <p>经度：E{{lng}}</p>
      <p>纬度：N{{lag}}</p>
    </div>
    <div :id="id" class="map"></div>
  </div>
</template>
<script>
import monitorIcon from '../../../../static/img/industryInformation/monitor-icon.png'
import echarts from 'echarts'
import axios from 'axios'
import Vue from 'vue'
import VueAMap, { lazyAMapApiLoaderInstance } from 'src/amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
  plugin: ['AMap.DistrictSearch', 'AMap.Polygon'],
  uiVersion: '1.0.11',
  v: '1.4.15'
});
const opts = { subdistrict: 0, extensions: 'all' };
const colors = [
  "#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00",
  "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707",
  "#651067", "#329262", "#5574a6", "#3b3eac"
];
const markers = [
  { point: [106.831977, 23.712686], content: '经度：106.831977 纬度：23.712686' },
  { point: [106.969063, 23.738953], content: '经度：106.969063 纬度：23.738953' },
  { point: [106.54027, 23.623629], content: '经度：106.54027 纬度：23.623629' }
];
const path = [
  [106.835325, 23.826152],
  [106.772154, 23.609897],
  [106.883391, 23.685375],
  // [106.972655, 23.72687],
  [106.835325, 23.826152]
]
const path1 = [
  [106.939488, 23.800139],
  [107.010213, 23.700837],
  [106.965581, 23.71404],
  [106.939488, 23.800139]
]
const path2 = [
  [106.542814, 23.650157],
  [106.601866, 23.601088],
  [106.481016, 23.577176],
  [106.542814, 23.650157]
]
export default {
  data() {
    return {
      id: `map-${Date.now()}`,
      areaName: '田阳县',
      map: null,
      district: null,
      districtExplorer: null,
      cityAdcode: '',
      cityName: '田阳县',
      lng: 0,
      lag: 0,
      isClick: false
    }
  },
  components: {
  },
  methods: {
    renderCity() {
      return new Promise(resolve => {
        this.district.search(this.cityName, (status, result) => {
          this.cityAdcode = result.districtList[0].adcode;
          const bounds = result.districtList[0].boundaries;
          const mask = [];
          for (let i = 0; i < bounds.length; i += 1) {
            mask.push([bounds[i]])
          }
          this.map = new AMap.Map(this.id, {
            mask,
            viewMode: '3D',
            zoom: 10.2,
            cursor: 'pointer',
            center: new AMap.LngLat(106.9156629745, 23.7356699750)
            // layers: [new AMap.TileLayer.Satellite()]
          });
          resolve();
        });
      });
    },
    handleMarkerClick(marker) {
      return () => {
        const extData = marker.getExtData();
        const infoWindow = new AMap.InfoWindow({
          content: '<div>title:' + extData.title + '<br/>content:' + extData.content + '</div>',
          offset: new AMap.Pixel(0, -35)
        });
        infoWindow.open(this.map, marker.getPosition());
      }
    },
    renderMarkers() {
      for (let i in markers) {
        const icon = new AMap.Icon({
          size: new AMap.Size(30, 30),
          imageSize: new AMap.Size(30, 30),
          image: monitorIcon
        });
        const marker = new AMap.Marker({
          position: new AMap.LngLat(markers[i].point[0], markers[i].point[1]),
          cursor: 'pointer',
          icon: icon,
          extData: markers[i]
        });
        marker.on('click', this.handleMarkerClick(marker));
        this.map.add(marker);
      }
    },
    createDistrictExplorer() {
      return new Promise(resolve => {
        AMapUI.load(['ui/geo/DistrictExplorer', 'lib/$'], (DistrictExplorer, $) => {
          this.districtExplorer = new DistrictExplorer({ eventSupport: true, map: this.map });
          resolve();
        });
      });
    },
    renderDistrict() {
      return new Promise(resolve => {
        this.districtExplorer.loadAreaNode(this.cityAdcode, (error, areaNode) => {
          console.log(error)
          this.districtExplorer.renderSubFeatures(areaNode, (feature, i) => {
            const fillColor = colors[i % colors.length]; // 填充色
            const strokeColor = colors[colors.length - 1 - i % colors.length]; // 边框色
            resolve();
            return {
              cursor: 'default',
              bubble: true,
              strokeColor, // 线颜色
              strokeOpacity: 1, // 线透明度
              strokeWeight: 1, // 线宽
              fillColor, // 填充色
              fillOpacity: 0.1 // 填充透明度
            };
          });
        });
      })
    },
    drawPath(path, index) {
      var polyline = new AMap.Polygon({
        path: path,
        isOutline: true,
        outlineColor: '#ffeeff',
        borderWeight: 1,
        strokeColor: "#19B4E7",
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: '#3AF3FF',
        // 折线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        strokeDasharray: [10, 5],
        lineJoin: 'round',
        lineCap: 'round',
        zIndex: 50
      })
      polyline.setMap(this.map)
      const that = this;
      polyline.on('click', function (e) {
        that.lng = e.lnglat.getLng()
        that.lag = e.lnglat.getLat()
        that.isClick = true
        that.$emit('indexChange', index)
      });
    },
    initMap() {
      lazyAMapApiLoaderInstance.load().then(async () => {
        this.district = new AMap.DistrictSearch(opts);
        await this.renderCity();
        // this.renderMarkers();
        await this.createDistrictExplorer();
        this.renderDistrict();
        await this.drawPath(path, 0)
        await this.drawPath(path1, 1)
        await this.drawPath(path2, 2)
      });
    }
  },
  mounted() {
    setTimeout(this.initMap, 2000);
  },
  created() {
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?428c8adc